/* 
  We...
  - Disable a set of links via css (add loading class to <a> and in button we nest a loader), 
    other specific links should be declared in the css,
    for a sample rule refer to scss/common/_buttons.scss ".is-loading")
  - Optionally add a class to each link
  - Includes a loader before your link
  <a href="#" classs="button">
    <span class="loader loader-bars">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </a>
*/
function disableLinks(linksArray, disableClss, addAnimation, innerAnimationMarkup) {
  var dClss = (disableClss) ? disableClss : "is-loading"; // no . in  the class name, added to the link
  var links = (linksArray && linksArray.length > 0 ) ? linksArray : null;
  var hasAnimation = (addAnimation) ? addAnimation : true;
  
  if(links){
    links.forEach(disableLink);
  }
  
  function disableLink(link) {
    var innerMRKP = ( innerAnimationMarkup) ? innerAnimationMarkup : "<span></span><span></span><span></span>";
    var loader = document.createElement('span');

    // This should be removed in your function when it's ready
    link.classList.add(dClss);

    if(hasAnimation && link.classList.contains("button")){
      loader.classList.add("loader");
      // The specific animation style for a loader
      loader.classList.add("loader-bars");
      loader.innerHTML = innerMRKP;

      // Add loader inside button
      link.appendChild(loader);
    }
  }
}